module.exports = __webpack_public_path__ + "img/ic-onlgris.e2187a5e.png";